(function ($, Drupal) {

  /**
   * Makes user go back to the previous page when clicking the back button.
   */
  Drupal.behaviors.inlineBackButton = {
    attach(context) {
      $('.inline-block.back-button a.back-link', context).each(function () {
        $(this).click(function(e) {
          e.preventDefault();
          window.history.back();
        });
      });
    }
  }

})(jQuery, Drupal);
